import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ResponseMessage } from '../../shared/models/response-message.interface';
import { GlobalWatchService } from '../../shared/services/global-watch.service';
import { Subscription } from 'rxjs';
import { StorageService } from '../../shared/services/storage.service';


@Component({
	selector: 'footer-component',
	templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

	public currentYear: number = new Date().getFullYear();

	public newsletterForm: FormGroup;
	public attemptedSubmit: boolean = false;
	public responseMsg: ResponseMessage;

	public hasCookieSub: Subscription;
	public hasCookie: boolean = false;

	// public testLink = 'Http://www.GOOGLE.com';
	// public testLink2 = '/privacy';
	
	constructor(
		private _globalWatchService: GlobalWatchService,
		private _storageService: StorageService,
		private _formBuilder: FormBuilder,
		private _router: Router
	) { }

	ngOnInit(): void {

		this.newsletterForm = this._formBuilder.group({
			emailAddress: ['', [Validators.required, Validators.email]],
		});

		this.hasCookie = this._storageService.getCookieBanner();
		//console.log('FooterComponent.hasCookie:', this.hasCookie);

		if(!this.hasCookie) {
			//console.log('FooterComponent. did not find cookie, start subscription');
			this.hasCookieSub = this._globalWatchService.hasCookie$
				.subscribe((data: boolean) => {
					this.hasCookie = data;
					//console.log('FooterComponent.hasCookieSub.hasCookie:', this.hasCookie);
				});
		}
		
	}

	ngOnDestroy(): void{
		if (this.hasCookieSub) this.hasCookieSub.unsubscribe();
	}



	/**
	 * Check for errors Client Side
	 */
	public checkErrors() {
		if (!this.attemptedSubmit) return;
		//console.log('checkErrors');

		this.responseMsg = {};
		if (this.newsletterForm.invalid) {
			this.responseMsg = {error: 'FORM INVALID'};
		}
	}


	public onSubmit () {
		// console.log('submit()');
		// console.log('newsletterForm:', this.newsletterForm.value);
		this.attemptedSubmit = true;

		// stop here if form is invalid
		if (this.newsletterForm.invalid) {
			this.responseMsg = {error: 'FORM INVALID'};
			console.error('this.newsletterForm.invalid');
			return;
		}

		alert('email valid. submit to a list somewhere.');


	}

}
